import { useNavigate } from "react-router-dom";
import { Accordion, Center, Title, Divider, Loader, Text, Stack, Box, Flex, Grid } from "@mantine/core";
import { IconBuilding, IconArrowDown } from "@tabler/icons-react";
import CareerList from "./CareerList";
import StatsResume from "./StatsResume";
import { FACULTY_COLORS } from "../../enums/FacultyColors";
import useActivePermission from '../../hooks/useActivePermission.js'
import { Category } from "../../enums/PermissionsEnums.js";

const FacultieAccordion = ({ faculties, loading }) => {
  const navigate = useNavigate();
  const activePermission = useActivePermission()
  
  //const allowAll = hasVicerrectoriaAccess(userPermissionss);

  // Memoizar facultades y carreras permitidas
  /*const { allowedFacultyCodes, allowedCareers } = useMemo(() => {
    let facultyCodes = [];
    let careerCodes = [];

    if (!allowAll) {

      if (hasFacultyAccess(userPermissionss)) {
        facultyCodes = userPermissionss
          .filter(({ permiso }) => permiso.categoria?.codigo.toLowerCase() === "facultad")
          .map(({ permiso }) => permiso.EntityId);
      
      } else if (isDirector(userPermissionss)) {
        careerCodes = userPermissionss
          .filter(
            ({ permiso, cargo }) =>
              permiso.categoria?.codigo.toLowerCase() === "carrera" &&
              cargo?.codigo.toLowerCase() === "director"
          )
          .map(({ permiso }) => permiso.EntityId);
      }
    }

    return { allowedFacultyCodes: facultyCodes, allowedCareers: careerCodes };
  }, [faculties, userPermissionss, allowAll]);*/

  const canAccessFaculty = (perm,facultyCode) => {
    const isAdmin = perm.permiso.categoria?.Id.toUpperCase() === Category.ADMINISTRATIVO
    if(isAdmin){
      return true;
    }else{
      const isFac = perm.permiso.categoria?.Id.toUpperCase() === Category.FACULTAD;
      const unitId = perm.permiso.EntityId.toUpperCase().trim();

      if(isFac && unitId === facultyCode.toUpperCase())
        return true;
    }
  }

  const handleSeeUnitDetails = (cod) => {
    navigate(`${cod}/detail`)
  };

  if (loading && faculties.length === 0) {
    return (
      <Center>
        <Stack align="center" justify="center">
          <Loader type="dots" size="md" mr={'sm'} color="#E72166"/> 
          <Text>Cargando facultades...</Text>
        </Stack>
      </Center>
    )
  }

  if (!loading && faculties.length === 0) {
    return (
      <Center>
        <Stack align="center" justify="center">
          <Text>Usted no dispone de facultades disponibles</Text>
        </Stack>
      </Center>
    )
  }

  return (
    <Accordion
      variant="separated"
      chevron={<IconArrowDown color="#E72166" />}
      chevronSize={30}
      multiple
    >
      {faculties.map((fac, index) => {
        const facultyColor = FACULTY_COLORS[fac.Codigo] || 'darkgray';
        const facultyAccess = canAccessFaculty(activePermission,fac.Codigo);

        return (
          <Accordion.Item key={index} value={fac.Descripcion}>
            <Accordion.Control style={{borderLeft: `10px solid ${facultyColor}`, }}>
              <Grid align="center">
                <Grid.Col span={{ base: 12, md: 5, lg: 4 }}>
                  <Title order={3} size={'1.6rem'} fw={400} ml={10}>
                    <Text span inherit c={facultyColor}>{fac.Codigo}</Text> - {fac.Descripcion ?? '[No disponible]'}
                  </Title>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 7, lg: 8 }}>
                  <Box mr={10}>
                    <StatsResume
                      unitType="f"
                      countEvidences={fac.Resumen?.Evidencias}
                      countWeakness={fac.Resumen?.Debilidades}
                      countStrengths={fac.Resumen?.Fortalezas}
                      buttonVisible={facultyAccess}
                      onClick={() => handleSeeUnitDetails(fac.Codigo)}
                    />
                  </Box>
                </Grid.Col>
              </Grid>
            </Accordion.Control>
            <Accordion.Panel style={{borderLeft: `5px solid ${facultyColor}`,}} >
              <Divider size="sm" mb="lg" />
              <CareerList facultieId={fac.Codigo} allowAll={facultyAccess} onSelectUnit={handleSeeUnitDetails} />
            </Accordion.Panel>
          </Accordion.Item>
        );
      })}
    </Accordion>
  );
};

export default FacultieAccordion;